<template>
    <md-dialog :md-active="showEditDialog">
        <md-dialog-title>
            Static Resource Editor
        </md-dialog-title>
        <md-dialog-content>
            <md-field>
                <label>Resource Name:</label>
                <md-input v-model="resourceInfo.name"></md-input>
            </md-field>
            <md-field>
                <label>Resource Type:</label>
                <md-select v-model="resourceInfo.type">
                    <md-option v-for="resType in resourceTypes" :key="resType" :value="resType">
                        {{resType}}
                    </md-option>
                </md-select>
            </md-field>
            <br>
            <div v-if="['Image', 'Video', 'Office File'].includes(resourceInfo.type)">
                <h3>Link to a resource:</h3>
                <md-field>
                    <label>Resource URL:</label>
                    <md-input v-model="resourceInfo.res_url"></md-input>
                </md-field>
            </div>
            <div v-show="['Image'].includes(resourceInfo.type) && !resourceInfo.res_url">
                <br>
                <h3>Or upload a resource:</h3>
                Accepts: Image Files (.png/.jpg/.gif)
                <vue-dropzone id="imgDropzone" :options="imgDropzoneOptions" v-on:vdropzone-success="fileUploaded">
                </vue-dropzone>
            </div>
            <div v-show="['Video'].includes(resourceInfo.type) && !resourceInfo.res_url">
                <br>
                <h3>Or upload a resource:</h3>
                Accepts: Video Files (.mp4)
                <vue-dropzone id="vidDropzone" :options="vidDropzoneOptions" v-on:vdropzone-success="fileUploaded">
                </vue-dropzone>
            </div>
            <div v-show="['Office File'].includes(resourceInfo.type) && !resourceInfo.res_url">
                <br>
                <h3>Or upload a resource:</h3>
                Accepts: {{officeDropzoneOptions.acceptedFiles}}
                <vue-dropzone id="officeDropzone" :options="officeDropzoneOptions" v-on:vdropzone-success="fileUploaded">
                </vue-dropzone>
            </div>
            <md-field v-if="['Youtube', 'Vimeo'].includes(resourceInfo.type)">
                <label>{{resourceInfo.type}} Resource ID:</label>
                <md-input v-model="resourceInfo.res_id"></md-input>
            </md-field>
            <div v-if="['Image', 'Video', 'Office File'].includes(resourceInfo.type)"> 
                <a :href="resourceInfo.res_url" target="_blank"> 
                    Resource test link 
                </a> 
            </div> 
            <div v-if="['Youtube'].includes(resourceInfo.type)"> 
                <a :href="'https://youtu.be/' + resourceInfo.res_id" target="_blank"> 
                    Resource test link 
                </a> 
            </div> 
            <div v-if="['Vimeo'].includes(resourceInfo.type)"> 
                <a :href="'https://vimeo.com/' + resourceInfo.res_id" target="_blank"> 
                    Resource test link 
                </a> 
            </div> 
            <br>
            <i class="hpi-warning">
                Please do not upload any 
                <a href="https://www.hhs.gov/hipaa/for-professionals/privacy/laws-regulations/index.html">
                    protected health information (PHI)
                </a> 
                nor any 
                <a href="https://en.wikipedia.org/wiki/Personally_identifiable_information">
                    personally identifying information (PII)
                </a>.
            </i>
        </md-dialog-content>
        <md-dialog-actions>
            <md-button class="md-accent md-raised" @click="$emit('closeEditDialog', 'delete')" style="position: absolute; left: 10px;">Delete</md-button> 
            <md-button class="md-primary" @click="$emit('closeEditDialog', 'cancel')">Close</md-button>
            <md-button class="md-primary md-raised" @click="saveResource()">Save</md-button>
        </md-dialog-actions>
    </md-dialog>
</template>

<script>
    import vueDropzone from 'vue2-dropzone'

    export default {
        props: {
            resourceInfo: {
                type: Object
            },
            showEditDialog: {
                type: Boolean
            }
        },
        components: {
            vueDropzone
        },
        data: function () {
            return {
                resourceTypes: [
                    "Image", "Video", "Office File",
                    "Youtube", "Vimeo"
                ],
                dropzoneOptions: {
                    maxFiles: 1,
                    url: this.$store.state.api_url + "/api/editor/uploadFile?jwt=" + this.$store.state.jwtToken,
                    thumbnailWidth: 150,
                    maxFilesize: 25, //megabytes
                },
            }
        },
        computed: {
            imgDropzoneOptions: function(){
                var opts = Object.assign({}, this.dropzoneOptions)
                opts.acceptedFiles = "image/*"
                return opts
            },
            vidDropzoneOptions: function(){
                var opts = Object.assign({}, this.dropzoneOptions)
                opts.acceptedFiles = "video/*"
                return opts
            },
            officeDropzoneOptions: function(){
                var opts = Object.assign({}, this.dropzoneOptions)
                opts.acceptedFiles = ".doc,.docx,.ppt,.pptx,.pdf,.xls,.xlsx"
                return opts
            }
        },
        methods: {
            fileUploaded: function(file, response){
                this.resourceInfo.name = file.name
                this.resourceInfo.res_url = this.$store.state.api_url + "/uploads/" + response
                this.saveResource()
            },
            saveResource: function(){
                this.$emit('closeEditDialog', 'save')
            }
        }
    }
</script>

<style src="vue2-dropzone/dist/vue2Dropzone.min.css">
</style>

<style scoped>
    .md-dialog{
        min-width: 80%;
        max-width: 650px;
        overflow: auto;
    }
    .hpi-warning{
        color: red;
    }
    .hpi-warning a{
        color: red;
    }
    .hpi-warning a:hover{
        color: #693838;
    }
</style>
